import { HISTORY_CHANGE } from "./data/DataController";
import { REALTIME_CHANGE } from "./data/BarStore";
import { NEW_BAR_SCROLL, resolveNewBarScroll } from "./scales/newBarScroll";

/**
 * Brings the view in step with a change of the bars. A tick moves only the
 * last bar of the series (smoothly, through the animator). Otherwise the
 * time axis and the series get all bars, and the time scale keeps showing
 * the same bars: older bars on the left do not move the view; what a new bar
 * on the right does depends on autoscroll (resolveNewBarScroll): while the
 * view scrolls with time (animator.isFollowingView) the bar lands in the
 * room it has opened, without animation the view slides by one bar. A new
 * history opens 15S / 30S with the first view and is shown at once.
 *
 * @param {string} change - HISTORY_CHANGE or REALTIME_CHANGE value
 * @param {object} engine - ChartEngine
 * @param {object} engine.data - DataController
 * @param {object} engine.timeScale
 * @param {object} engine.timeAxis
 * @param {object} engine.animator - passes the shown bars to the series
 * @param {object} engine.secondsFirstView
 * @param {{ autoscrollEnabled: boolean }} engine.toggles
 */
export const syncViewWithBars = (
  change,
  { data, timeScale, timeAxis, animator, secondsFirstView, toggles },
) => {
  const { store } = data;

  if (change === REALTIME_CHANGE.LAST_BAR_UPDATED) {
    animator.updateLastBar(store.bars);
    return;
  }

  const isNewBar = change === REALTIME_CHANGE.BAR_APPENDED;

  if (isNewBar) {
    animator.appendBar(
      animator.isFollowingView ||
        resolveNewBarScroll(timeScale, toggles.autoscrollEnabled) === NEW_BAR_SCROLL.FOLLOW,
    );
  } else {
    timeScale.setLastIndex(store.lastIndex);
  }

  timeAxis.setBars(store.bars, data.barDurationMs);
  animator.setBars(store.bars, isNewBar);

  if (change === HISTORY_CHANGE.REPLACED) {
    secondsFirstView.apply(timeScale, data.resolution);
    animator.snap();
  }
};
